
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'WavyLine',
  props: {
    zigzag: {
      type: Boolean,
      default: false
    }
  }
})
